var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin-common-spacer"},[_c('div',{staticClass:"plugin-common-spacer__desktop",style:(_vm.desktopStyles)}),_c('div',{staticClass:"plugin-common-spacer__mobile",style:(_vm.mobileStyles)})])}
var staticRenderFns = []

export { render, staticRenderFns }